import { PlansPageSortOptions } from 'types';

export const plansPageSortOptions = [
  { label: 'Most popular', value: PlansPageSortOptions.most_popular },
  { label: 'Price low to high', value: PlansPageSortOptions.price_low_to_high },
  { label: 'Price high to low', value: PlansPageSortOptions.price_high_to_low },
  { label: 'Fastest speed', value: PlansPageSortOptions.fastest_speed },
];
